<template>
    <!--
        TODO:
            - [ ] Improvement @TFU: Add possibility to alter data in prototype from within FormDialog
    -->
    <div class="prototype-wrapper">
        <div
            v-for="(view, key) in views"
            :key="key"
            class="prototype-view"
        >
            <slot v-if="currentView === key" :name="`view-${key}`" v-bind="{ state, ...view, setCurrentView }" />
        </div>
        <q-menu
            touch-position
            context-menu
        >
            <q-list dense>
                <q-item clickable>
                    <q-item-section>
                        <q-item-label>Set View</q-item-label>
                    </q-item-section>
                    <q-menu anchor="top end" self="top start">
                        <q-list dense>
                            <q-item
                                v-for="(view, key) in views"
                                :key="key"
                                clickable
                                :disable="currentView === key"
                                @click="setCurrentView(key)"
                            >
                                <q-item-section>
                                    <q-item-label>{{ key }}</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                    <q-item-submenu-indicator />
                </q-item>
                <q-item
                    :disable="Object.keys(views[currentView].actions).length === 0"
                    clickable>
                    <q-item-section>
                        <q-item-label>Actions</q-item-label>
                    </q-item-section>
                    <q-menu anchor="top end" self="top start">
                        <q-list dense>
                            <q-item
                                v-for="(action, key) in views[currentView].actions"
                                :key="key"
                                clickable
                                @click="action"
                            >
                                <q-item-section>
                                    <q-item-label>{{ key }}</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                    <q-item-submenu-indicator />
                </q-item>
            </q-list>
        </q-menu>
    </div>
</template>

<script>
import QItemSubmenuIndicator from '@/components/QItemSubmenuIndicator.vue'
import { computed, reactive, ref } from 'vue'

export default {
    name: 'Prototype',
    components: { QItemSubmenuIndicator },
    props: {
        state: {
            type: Object,
            default: () => {
                return {}
            },
        },
        views: {
            type: Object,
            required: true,
        },
    },
    setup (props) {
        const state = computed(() => {
            return reactive({...props.state});
        })

        const currentView = ref(Object.keys(props.views).at(0));
        function setCurrentView(view) {
            currentView.value = view;
        }
        const views = computed(() => {
            const views = {};
            for (const key in props.views) {
                const viewState = reactive({...props.views[key].viewState || {}});

                const wrappedActions = {};
                if (props.views[key].actions) {
                    for (const action in props.views[key].actions) {
                        const originalAction = props.views[key].actions[action];
                        wrappedActions[action] = () => originalAction(state.value, viewState);
                    }
                }

                views[key] = {
                    viewState,
                    actions: wrappedActions,
                };
            }
            return views;
        });
        return {
            state,
            currentView,
            setCurrentView,
            views,
        }
    },
}
</script>

<style lang="scss" scoped>
// Make wrapper elements not influence the layout
.prototype-wrapper,
.prototype-view {
    display: contents;
}

// Fix layout issues (flex/columns)

// Generate column classes for all breakpoints
$breakpoints: (xs, sm, md, lg, xl);
$columns: 12;

// Breakpoint mixins to match project's Quasar configuration
// Using the values from the project's variables
@mixin for-xs-up {
  @media (min-width: 0) {
    @content;
  }
}

@mixin for-sm-up {
  @media (min-width: 600px) {
    @content;
  }
}

@mixin for-md-up {
  @media (min-width: 1024px) {
    @content;
  }
}

@mixin for-lg-up {
  @media (min-width: 1600px) {
    @content;
  }
}

@mixin for-xl-up {
  @media (min-width: 1920px) {
    @content;
  }
}

// Mixin to generate column classes for a specific breakpoint
@mixin col-classes($breakpoint) {
  @for $i from 1 through $columns {
    > .col-#{$breakpoint}-#{$i} {
      width: percentage($i / $columns);
      //padding: 0 12px; // Standard grid padding
      box-sizing: border-box;
    }
  }
}

// Apply column classes for each breakpoint
.prototype-view {
  @include for-xs-up {
    @include col-classes('xs');
  }

  @include for-sm-up {
    @include col-classes('sm');
  }

  @include for-md-up {
    @include col-classes('md');
  }

  @include for-lg-up {
    @include col-classes('lg');
  }

  @include for-xl-up {
    @include col-classes('xl');
  }
}

// Extend gutter styles for elements nested in .prototype-wrapper and .prototype-view
// Define sizes and their corresponding padding values
$gutter-sizes: (
  'xs': 4px,
  'sm': 8px,
  'md': 16px,
  'lg': 24px,
  'xl': 48px
);

// Generate gutter styles for all sizes and directions
@each $size, $padding in $gutter-sizes {
  // General gutter (both x and y)
  .q-col-gutter-#{$size} {
    > .prototype-wrapper > .prototype-view > * {
      padding: $padding 0 0 $padding;
    }
  }

  // X-axis gutter
  .q-col-gutter-x-#{$size} {
    > .prototype-wrapper > .prototype-view > * {
      padding-left: $padding;
      padding-right: 0;
    }
  }

  // Y-axis gutter
  .q-col-gutter-y-#{$size} {
    > .prototype-wrapper > .prototype-view > * {
      padding-top: $padding;
      padding-bottom: 0;
    }
  }
}

</style>
